import React from "react";
import _ from "lodash";

export interface IGreenListForm<P extends IGreenListFormProps, S extends IGreenListFormState> extends React.Component<P, S> {
	isValid: ( isUserAction: boolean ) => boolean;
}

export interface IGreenListFormProps {
	onUpdated: <T>( isValid: boolean, Data?: T ) => void;
}

export interface IGreenListFormState {
	isValid: boolean;
}

export function handleDataUpdate<P extends IGreenListFormProps, S extends IGreenListFormState, D>
( oldData: D, newData: D, prevState: S, cmp: IGreenListForm<P, S> ) {
	if ( !_.isEqual( oldData, newData ) ) {
		const isValidNow = cmp.isValid( false );
		if ( prevState.isValid !== isValidNow ) {
			cmp.setState( { isValid: isValidNow }, () => {
				cmp.props.onUpdated( isValidNow, newData );
			} );
		}
	}
}
